export default __webpack_public_path__ + "static/stick-db20ef7526f086ce4f6e372a9f8b1605.png";